export default {
  title: '404',
  message: "Whoops! It looks like there's nothing here!"
};
